import {observer} from 'mobx-react-lite'
import React from 'react'
import {IconWithoutColor} from '@components/main-menu/components/icon-without-color'
import {cn} from '@containers/html-utils'
import {globals} from '@extensions/globals-base'
import {GroupChatProxy} from '@extensions/proxies/group-chat-proxy'
import {gotoGroup} from '../../handlers/main-handlers'
import {TwChatItemText, TwItem, TwMentionSymbol, TwMsgCount} from './containers'

const getCount = (u: GroupChatProxy) => {
  const hasMentions = u.getNewMentionsAmount() > 0
  const isNotified = u.users.get(globals.currentUserId)?.isNotified
  if (!isNotified) {
    return {
      hasMentions,
      count: u.messagesCount
    }
  }

  const newMsgCount = u.newMessagesAmount
  const msgCount = u.messagesCount

  const hasNewMsg = newMsgCount > 0

  if (hasNewMsg) {
    return {
      hasMentions,
      count: u.newMessagesAmount
    }
  }

  return {
    hasMentions,
    count: msgCount
  }
}

export const GroupProjectListItem = observer(({u}: {u: GroupChatProxy}) => {
  const newMsgCount = u.newMessagesAmount

  const hasNewMsg = newMsgCount > 0

  const markImportant = !!u.markImportant
  const isNotified = u.users.get(globals.currentUserId)?.isNotified

  const {hasMentions, count} = getCount(u)

  return (
    <TwItem onClick={() => gotoGroup(u)}>
      <IconWithoutColor icon="IconMessage" size={16} />

      <TwChatItemText>{u.chatName}</TwChatItemText>

      {markImportant && (
        <TwMsgCount className={cn('ml-auto')} $hasNewMsg={true}>
          {'!'}
        </TwMsgCount>
      )}

      <TwMsgCount
        className={cn(!markImportant && 'ml-auto')}
        $hasNewMsg={!!(hasNewMsg && isNotified)}
      >
        {hasMentions && <TwMentionSymbol>@</TwMentionSymbol>} {count}
      </TwMsgCount>
    </TwItem>
  )
})
